
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Client } from '@/types';

@Component
export default class ClientList extends Vue {
  @Prop({ type: Array, default: [] }) clients!: Array<Client>;

  @Prop({ type: Boolean, default: false }) noLinks!: boolean;
}
